import React from "react";
import './privacypolicystyle.css';

function EMoniTermsConditions() {

    return (
        <div class="container">
            <h1 style={{ textAlign: 'center' }}><strong>Vodafone Cook Islands <br />E-Moni Terms &amp; Conditions</strong></h1>

            <ol>
                <li><p>
                    <strong>Definitions:</strong> In this Agreement, unless the context requires otherwise:
                    <br />
                    <br />
                    <strong>"Account"</strong> means a Registered User’s account maintained by us including a record of the person’s E-Moni balance and transactions;<br />
                    <strong>"Agreement"</strong> means the Registration Form, these Terms, and our policies, which together form a legally binding contract between the Registered User and Vodafone;<br />
                    <strong>"Authorised Outlet"</strong> means a Vodafone outlet or third party authorised by us to provide E-Moni Services;<br />
                    <strong>"E-Moni App"</strong> means our mobile application the Registered User uses to access their Account and make transactions;<br />
                    <strong>"E-Moni"</strong> means the electronic value of your entitlement to cash held by Vodafone on your behalf;<br />
                    <strong>"E-Moni Services"</strong> means our E-Moni services, namely providing you with an Account and the ability to debit or credit the Account, including to transfer E-Moni, or use E-Moni to pay bills and purchase goods or services;<br />
                    <strong>"Fees"</strong> refers to our fees for E-Moni Services and correspondingly “fee” refers to a particular transaction fee;<br />
                    <strong>"KYC information"</strong> means Know Your Customer information and comprises of any information required by law to be collected from a Registered User at any time to verify their identity or for the detection and prevention of criminal offences such as money laundering and terrorism;<br />
                    <strong>"Personal Information"</strong> is information about you that we have in our records and includes KYC Information, your mobile number, and your Account records;<br />
                    <strong>"PIN"</strong> means the personal identification number you will use to access your Account;<br />
                    <strong>"Registration Form"</strong> means the registration form to sign up for an Account;<br />
                    <strong>"Registered User", "you" and "your"</strong> means any person with an Account;<br />
                    <strong>"System"</strong> means the technical, administrative and contractual systems we use to provide E-Moni Services and includes the E-Moni App;<br />
                    <strong>"Terms"</strong> means these E-Moni Terms and Conditions;<br />
                    <strong>"Vodafone", "our", or "we"</strong> means Telecom Cook Islands Limited t/a Vodafone Cook Islands;<br />
                    <strong>"VAT"</strong> refers to value added tax applicable to E-Moni Services;<br />
                    <strong>"your mobile number"</strong> refers to the mobile telephone number registered to an Account;<br />

                </p>

                </li>
                <li>
                    <strong>Registration:</strong> To activate your Account, you must provide a completed and signed Registration Form together with any photo identification, proof of residence and other KYC Information we may require.
                </li>
                <li>
                    <strong>Activation & PIN: </strong>
                    If we approve your registration, we will provide you with an activation code that you will use to activate your Account through the E-Moni App. You will be required to select a PIN that you will use to access your Account. <strong>You must keep your PIN secret and not disclose it to anyone.</strong>
                </li>
                <li>
                    <strong>Commencement of this Agreement: </strong>
                    This Agreement will commence when you activate your Account
                </li>
                <li>
                    <strong>E-Moni Services: </strong>
                    Once you have activated your Account, you can use the E-Moni Services as follows:
                    <ol type="a">
                        <li>
                            Go to any Authorised Outlet to credit your Account with E-Moni or to make a withdrawal;
                        </li>
                        <li>
                            Transfer E-Moni to any Registered User;
                        </li>
                        <li>
                            Pay for bills;
                        </li>
                        <li>
                            Purchase goods or services using E-Moni at any
                            Authorised Outlet.
                        </li>
                    </ol>
                </li>
                <li>
                    <strong>Fees: </strong>
                    You will be charged a fee per transaction to use E-Moni Services. A full list of our Fees is available on our website at <a href="https://www.vodafone.co.ck/e-moni">www.vodafone.co.ck/e-moni</a>. Fees are inclusive of VAT.
                </li>
                <li>
                    <strong>Transaction prerequisite: </strong>
                    Your Account must be in credit before you can use E-Moni Services. Also, if your Account balance is insufficient to pay our fee for a given transaction you would like to make, the transaction will not be processed.
                </li>
                <li>
                    <strong>Our commitment to you: </strong>
                    <ol type="a">
                        <li>We will ensure that the E-Moni balance and transactions on your Account are accurate at all times;</li>
                        <li>Subject to scheduled interruptions for System maintenance and repairs, and unforeseen System outages, we will ensure you can access your Account 24/7;</li>
                        <li>You can credit or make a withdrawal from your Account at any Authorised Outlet during its normal opening hours.</li>
                    </ol>
                </li>
                <li>
                    <strong>Your commitment to us:  </strong> <br />You agree:
                    <ol type="a">
                        <li>We will ensure that the E-Moni balance and transactions on your Account are accurate at all times;</li>
                        <li>Subject to scheduled interruptions for System maintenance and repairs, and unforeseen System outages, we will ensure you can access your Account 24/7;</li>
                        <li>You can credit or make a withdrawal from your Account at any Authorised Outlet during its normal opening hours.</li>
                    </ol>
                </li>
                <li>
                    <strong>Suspension of Account: </strong>
                    We may suspend your Account or decline to process any transaction if we believe that you have breached these Terms; your Account is being accessed without authorisation; or your Account is being used in an unlawful or fraudulent manner.
                </li>
                <li>
                    <strong>Account closure: </strong>
                    We will close your Account on your request and any E-Moni in your Account, after deducting any Fees owing, will be redeemed for cash and paid to you. We may decide to close your Account for any of the reasons set out in clause 10 or if we are no longer providing E-Moni Services. We may do this either with or without notice to you. If we close your Account, your access to the E-Moni App will be disabled.
                </li>
                <li>
                    <strong>Know Your Customer: </strong>
                    Vodafone is required by law to verify the identity of all Registered Users and to collect and keep up to date KYC Information on file. We may ask you to update your KYC Information at any time in order to maintain your Account.
                </li>
                <li>
                    <strong>Storage, use and release of information: </strong>
                    Our Privacy Policy applies to our relationship with you. You can access our Privacy Policy <a href="http://www.vodafone.co.ck/privacy-policy">here</a>. We use Cookies to optimise your user experience on the E-Moni App. Cookies are small files that are stored on your device when you visit a website. The Cookies mean that the website will remember you and how you’ve used the site every time you come back. The E-Moni app may not function or may have limited functionality if your web browser does not accept Cookies.
                </li>
                <li>
                    <strong>E-Moni App: </strong>
                    <ol type="a">
                        <li>The E-Moni App is available free of charge to Registered Users so that they can use E-Moni Services;</li>
                        <li>We grant you a non-exclusive, non-transferable licence to use the E-Moni App for E-Moni Services. This licence ends when your Account is closed;</li>
                        <li>You do not have any rights in the E-Moni App;</li>
                        <li>You agree not to resell, distribute, copy, modify, reverse engineer, attempt to extract the source code of the E-Moni App or otherwise deal with the application contrary to its intended purpose;</li>
                        <li>We do not guarantee the availability of the E-Moni App 24/7. It is provided to you ‘as is’ and without support or maintenance. However, we may carry out repairs or maintenance at our discretion and at any time either with or without notice to you;</li>
                        <li>You agree to follow any reasonable instructions we may give you regarding the use of the E-Moni App, including to enable Cookies or for downloading any updates to the application.</li>
                    </ol>
                </li>
                <li>
                    <strong>Communicating with you via SMS: </strong>
                    Vodafone reserves the right to send you SMS about our services and promotions from time to time.
                </li>
                <li>
                    <strong>Complaints: </strong>
                    If you have a concern or complaint regarding our services you can let us know by calling 123 or by emailing us at <a href="mailto:info@vodafone.co.ck">info@vodafone.co.ck</a>. Our Customer Complaints & Disputes Policy is available on our website.
                </li>
                <li>
                    <strong>Limitation of liability: </strong>
                    Vodafone is not liable for any loss suffered by you under this Agreement unless it is directly caused by our gross negligence. Furthermore, Vodafone’s total liability to you under this Agreement is limited to NZD$5,000 in the aggregate.
                </li>
                <li>
                    <strong>No warranties: </strong>
                    To the maximum extent permitted by law Vodafone excludes warranties of any kind, either express or implied. In particular, we do not warrant that our services are fault or error free.
                </li>
                <li>
                    <strong>Acknowledgements: </strong>
                    You acknowledge that availability of our services and/or the functionality of any applications used together with the services may be impacted or limited by features of your device; your connection to the internet; or if you do not update the E-Moni App as required.
                </li>
                <li>
                    <strong>Intellectual property: </strong>
                    You agree not to do anything that would infringe our intellectual property rights or the rights belonging to entities in the Vodafone family, such as Vodafone Fiji PTE Limited and Vodafone Group Plc, including:
                    <ol type="a">
                        <li>the Vodafone brand and all associated marks, taglines and other related intellectual property; and</li>
                        <li>the E-Moni App and all trademarks, copyright, database rights and other related intellectual property rights.</li>
                    </ol>
                </li>
                <li>
                    <strong>Proceeds of crime and money laundering: </strong>
                    E-Moni Services are regulated by the Cook Islands Financial Supervisory Commission (FSC). If we are required to comply with any law, order, instruction or direction for the prevention of criminal activity or generally to comply with FSC requirements, any act or omission taken on our behalf for the purpose of complying will not be considered a breach of these Terms.
                </li>

                <li>
                    <strong>Changes to these Terms: </strong>
                    We may change these Terms at any time. You can find the current Terms on our website <a href="www.vodafone.co.ck/e-moni-tncs">here</a>.
                </li>
                <li>
                    <strong>Successors & Assigns: </strong>
                    This Agreement is binding on the Registered User’s legal representatives, successors and assigns.
                </li>
                <li>
                    <strong>Governing law: </strong>
                    These Terms are governed by the laws of the Cook Islands.
                </li>
            </ol>

        </div>

    )


}

export default EMoniTermsConditions;